import {
  dispatchNotificationsChanged,
  isCommentNotification,
  isMessageNotification,
  isUnreadNotification,
  normalizeNotificationsResponse,
  notificationMatchesConversation,
  notificationMatchesWorkoutComment,
} from "./notificationPayload";

const getNotificationId = (n) => {
  if (!n) return "";
  const raw = n.id ?? n._id ?? n.notificationId ?? n.uuid;
  return raw != null ? String(raw) : "";
};

async function markMatchingUnread(api, predicate) {
  const { fetchUnreadNotifications, markNotificationRead } = api;
  const raw = await fetchUnreadNotifications();
  const list = normalizeNotificationsResponse(raw).filter(
    (n) => isUnreadNotification(n) && predicate(n)
  );
  await Promise.all(
    list.map((n) => {
      const id = getNotificationId(n);
      const sk = n.sk;
      if (!id || !sk) return Promise.resolve();
      return markNotificationRead(id, String(sk)).catch(() => null);
    })
  );
  if (list.length > 0) {
    dispatchNotificationsChanged();
  }
  return list.length;
}

/** Clear inbox + message bell items for a conversation after the user replies. */
export async function clearMessageNotificationsForConversation(api, conversationId) {
  if (!conversationId) return 0;
  return markMatchingUnread(
    api,
    (n) =>
      isMessageNotification(n) &&
      notificationMatchesConversation(n, conversationId)
  );
}

/** Clear comment notifications for one exercise after the user replies. */
export async function clearCommentNotificationsForExercise(
  api,
  workoutId,
  exerciseIndex
) {
  if (!workoutId) return 0;
  return markMatchingUnread(api, (n) =>
    notificationMatchesWorkoutComment(n, workoutId, exerciseIndex)
  );
}

/** Clear all comment notifications for a workout when it is marked reviewed. */
export async function clearCommentNotificationsForWorkout(api, workoutId) {
  if (!workoutId) return 0;
  return markMatchingUnread(
    api,
    (n) =>
      isCommentNotification(n) &&
      notificationMatchesWorkoutComment(n, workoutId, undefined)
  );
}
